import { render, staticRenderFns } from "./productPart.vue?vue&type=template&id=14d6a02d&scoped=true"
import script from "./productPart.vue?vue&type=script&lang=js"
export * from "./productPart.vue?vue&type=script&lang=js"
import style0 from "./productPart.vue?vue&type=style&index=0&id=14d6a02d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d6a02d",
  null
  
)

export default component.exports